export default {
    base_page: {
        title: 'Барои амволи худ чунин модули бронкунӣ мехоҳед?',
        description: 'Ин модули бронкунӣ бо ёрии RealtyCalendar сохта шудааст',
        button: 'Муфассалтар',
    },
    common: {
        months: [
            'январ',
            'феврал',
            'март',
            'апрел',
            'май',
            'июн',
            'июл',
            'август',
            'сентябр',
            'октябр',
            'ноябр',
            'декабр',
        ],
        back: 'Бозгашт',
        book: 'Брон кардан',
        more: 'Муфассал',
        from: 'аз',
        find: 'Ёфтан',
        reset: 'Аз нав танзим кардан',
        apply: 'Истифода бурдан',
        cancel: 'Бекор кардан',
        close: 'Пӯшидан',
        print: 'Чоп кардан',
        change: 'Тағйир додан',
        arrival: 'Омад',
        by_list: 'Рӯйхат',
        by_map: 'Дар харита',
        download_confirmation: 'Боргирии тасдиқи брон',
        guests: {
            adults: 'Калонсолон',
            child: 'Кӯдак:',
            add_child: 'Илова кардани кӯдак',
            guest: '{count} меҳмон | {count} меҳмон | {count} меҳмон | {count} меҳмон | {count} меҳмон',
            child_count: '{count} кӯдак | {count} кӯдак | {count} кӯдак | {count} кӯдак | {count} кӯдак',
            list: 'Рӯйхати меҳмонон',
        },
        confirm_close: {
            title: 'Оё шумо воқеан мехоҳед тирезаро пӯшед?',
            text: 'Ҳангоми пӯшидан маълумоти бронкунии шумо гум мешавад.',
        },
        meta: {
            title: 'Модули бронкунӣ',
            description: 'Ҷойи зисти беҳтарин шуморо интизор аст. Дар чанд сония брон кунед!',
        },
        select_date: 'Интихоби сана',
        departure: 'Баромад',
        refresh: 'Навсозӣ',
        year: '{count} сол | {count} сол | {count} сол | {count} сол | {count} сол',
    },
    calendar: {
        check_in: 'Даромад',
        check_out: 'Баромад',
        check_in_check_out: 'Даромад–Баромад',
        select_date: 'Санаро интихоб кунед',
        select_check_in_date: 'Санаи даромадро интихоб кунед',
        select_check_out_date: 'Санаи баромадро интихоб кунед',
        departure_only_hint: 'танҳо баромад имконпазир аст',
        check_in_date_with_time: 'Даромад {date} - Санаи баромадро интихоб кунед',
        check_in_check_out_dates: 'Даромад {checkIn} - баромад {checkOut}',
        check_in_date: 'Санаи воридшавӣ',
        check_out_date: 'Санаи баромад',
        booking_min_days: 'Ҳадди ақали брон: {days} рӯз',
        discount_days: 'тахфиф аз {days} рӯз',
        while_staying: 'ҳангоми истиқомат',
    },
    basket: {
        title: 'Бронкунӣ',
        arrival_time: 'Вақти даромад',
        departure_time: 'Вақти баромад',
        select_time: 'Вақтро интихоб кунед',
        booking_params: 'Параметрҳои бронкунӣ',
        form: {
            first_name: 'Ном',
            last_name: 'Насаб',
            phone: 'Телефон',
            additional_phone: 'Телефони иловагӣ (ихтиёрӣ)',
            email: 'Email',
            email_optional: 'Email (ихтиёрӣ)',
            wishes: 'Хоҳишҳои шумо (ихтиёрӣ)',
            enter_name: 'Номро ворид кунед',
            enter_last_name: 'Насабро ворид кунед',
            enter_phone: 'Рақамро ворид кунед',
            enter_email: 'Email-ро ворид кунед',
            placeholder_wishes: 'Барои соҳиби хона ёддошт гузоред',
        },
        price: {
            cost: 'Арзиш',
            select_tariff: 'Тарофро интихоб кунед',
            stay_amount: 'Маблағ {period}',
            total: 'Ҳамагӣ',
            long_stay_discount: 'Тахфиф барои иқомати дарозмуддат',
            rate_discount: 'Тахфиф аз рӯи тариф',
            promo_code_discount: 'Тахфифи промокод',
            processing_fee: 'Коркарди пардохт',
            payment_system_fee: 'Комиссияи низоми пардохт',
            service_fee: 'Пардохти хизматрасонӣ',
            service_fee_tooltip: 'Маблағ аввал ба ҳисоби низоми пардохт ворид мешавад ва пас аз баромади шумо ба соҳиби хона гузаронда мешавад. Пардохти хизматрасонӣ амнияти анҷоми муомиларо таъмин намуда, манфиатҳои шуморо ҳамчун меҳмон ҳимоя мекунад.',
            pay_now: 'Маблағи пардохтшаванда ҳозир',
            pay_later: 'Ҳангоми даромад пардохт кунед',
            pay_later_tooltip: 'Соҳиби объект пешакӣ бо шумо тамос мегирад, то шарҳ диҳад, ки чӣ гуна пардохт кунед. Баъзе соҳибон метавонанд инчунин гарав талаб кунанд.',
            select_dates_and_guests: 'Санаҳои даромад/баромад ва шумораи меҳмононро интихоб кунед',
            payment_method: {
                title: 'Тарзи пардохт',
                sbp: 'SBP',
                card: 'Корти бонкӣ',
            },
        },
        agreement: {
            text: `Ман ба {consentLink}коркарди маълумоти шахсӣ розигӣ медиҳам{/consentLink},
        ва тасдиқ мекунам, ки бо {bookingRulesLink}Қоидаҳои бронкунӣ{/bookingRulesLink},
        шартҳои офертаи {safeTransactionsLink}Интиқоли бе хатар{/safeTransactionsLink}
        ва {privacyLink}Сиёсати коркарди маълумоти шахсӣ{/privacyLink} шинос шудаам.`,
            consent_text: `Ман ба {consentLink}коркарди маълумоти шахсӣ розигӣ медиҳам{/consentLink}.`,
            rules_text: `Тасдиқ мекунам, ки бо {bookingRulesLink}Қоидаҳои бронкунӣ{/bookingRulesLink}, шартҳои офертаи {safeTransactionsLink}Интиқоли бе хатар{/safeTransactionsLink} ва {privacyLink}Сиёсати коркарди маълумоти шахсӣ{/privacyLink} шинос шудаам.`,
            safe_transactions: 'Интиқоли бехатар',
            privacy_policy: 'Сиёсати коркарди маълумоти шахсӣ',
            accommodation_rules: 'Қоидаҳои иқомат',
            booking_rules: 'Қоидаҳои бронкунӣ',
            foreign: {
                text: `Ман бо {agreementLink}шартҳои бронкунӣ, қоидаҳои истиқомат ва сиёсати махфият{/agreementLink} розӣ ҳастам.`,
            },
        },
        validation: {
            enter_check_in_date: 'Санаи даромадро интихоб кунед',
            enter_check_out_date: 'Санаи баромадро интихоб кунед',
            enter_name_required: 'Номро ворид кунед',
            name_min_length: 'Ном бояд ҳадди ақал 2 рамз дошта бошад',
            name_letters_only: 'Ном метавонад танҳо аз ҳарфҳо иборат бошад',
            enter_last_name_required: 'Насабро ворид кунед',
            last_name_min_length: 'Насаб бояд ҳадди ақал 2 рамз дошта бошад',
            last_name_letters_only: 'Насаб метавонад танҳо аз ҳарфҳо иборат бошад',
            enter_phone_required: 'Рақами телефонро ворид кунед',
            phone_invalid: 'Рақами дурусти телефонро ворид кунед',
            enter_email_required: 'Email-ро ворид кунед',
            email_invalid: 'Email-и дурустро ворид кунед',
        },
        payment: {
            timer_text: 'Пешпардохтро ҳарчи зудтар анҷом диҳед, то ҳангоми озод будани ҷой онро нигоҳ доред. Шумо ба хидмати пардохт равона карда мешавед. Пас аз пардохт объект барои шумо брон карда мешавад.',
        },
        promocode: {
            enter_promocode: 'Ворид кардани промокод',
            promocode: 'Промокод',
            enter_code: 'Промокодро ворид кунед',
            discount: 'Тахфиф бо промокод',
        },
    },
    hotel: {
        details: {
            description: 'Тавсиф',
            amenities: 'Шуморо кадом шароит интизор аст',
            show_all_amenities: 'Намоиши ҳамаи шароитҳо: {count}',
            address: 'Суроға',
            classification_certificate: 'Шаҳодатнома дар бораи додани категория № {number}',
        },
        apartment: {
            room: '{count} ҳуҷра | {count} ҳуҷра | {count} ҳуҷра | {count} ҳуҷра | {count} ҳуҷра',
            bed: '{count} ҷойи хоб | {count} ҷойи хоб | {count} ҷойи хоб | {count} ҷойи хоб | {count} ҷойи хоб',
            available_dates: 'Санаҳои дастрас',
            date_range_sold_out: 'Барои {range} ҷой пур аст.',
            select_free_dates: 'Санаҳои холиро дар тақвим интихоб кунед.',
            booking_available_from: 'бронкунӣ аз {minStay} шаб дастрас аст.',
            date_range_on: 'Барои {range}',
            rooms: 'Ҳуҷраҳо',
            area: 'Масоҳат',
            floor: 'Ошёна',
            beds: 'Ҷойи хоб',
            day_off: 'барои {count} рӯз | барои {count} рӯз | барои {count} рӯз | барои {count} рӯз | барои {count} рӯз',
            night_off: 'барои {count} шаб | барои {count} шаб | барои {count} шаб | барои {count} шаб | барои {count} шаб',
        },
        map: {
            found: 'Ёфт шуд',
            scroll: 'Барои дидани ҳама, ба поён ҳаракат кунед',
            variant: '{count} вариант | {count} вариант | {count} вариант | {count} вариант | {count} вариант',
            metro: 'Метро',
        },
    },
    room_attributes: {
        washing_machine: 'Мошинаи ҷомашӯӣ',
        wi_fi: 'Интернет Wi-Fi',
        tv: 'Телевизор',
        air_conditioning: 'Кондиционер',
        refrigerator: 'Яхдон',
        dishwasher: 'Мошинаи зарфшӯйӣ',
        music_center: 'Маркази мусиқӣ',
        microwave: 'Танӯри микроволновка',
        iron: 'Дарзмол ва тахтаи дарзмолкунӣ',
        concierge: 'Консьерж',
        parking: 'Таваққуфгоҳ',
        safe: 'Сейф',
        waterheater: 'Обгармкунак',
        bathroom: 'Лавозимоти ҳаммом',
        animals: 'Бо ҳайвонот мумкин',
        smoke: 'Тамокукашӣ мумкин',
        balcony: 'Балкон',
        elevator: 'Лифт',
        romantic: 'Барои вохӯриҳои романтикӣ',
        jacuzzi: 'Бо ҷакузи',
        kids: 'Бо кӯдакон мумкин',
        party: 'Барои чорабиниҳо',
        telephone: 'Телефон',
        stove: 'Плитаи ошхона',
        cabletv: 'Телевизиони кабелӣ',
        pool: 'Ҳавз',
        seafront: 'Хати якуми соҳил',
        playground: 'Майдончai кӯдакон',
        sauna: 'Сауна / ҳаммом',
        transfer: 'Трансфер',
        seaview: 'Манзара ба баҳр',
        mountainview: 'Манзара ба кӯҳҳо',
        crib: 'Гаҳвора (катчаи кӯдакона)',
    },
    error: {
        map_loading_failed: 'Бор кардани ҳамаи объектҳои дастрас муяссар нашуд.',
        no_rooms: 'Ҷойҳои холӣ нест',
        no_rooms_text: 'Барои санаҳои интихобшуда вариантҳои холӣ ёфт нашуданд. Лутфан бо мо тамос гиред — мо ҳамеша чизе барои пешниҳод дорем!',
        occurred: 'Хато рух дод',
        booking_error_text: 'Чизе нодуруст шуд, бо мо тамос гиред:',
        connect_error_text: 'Ҳангоми ҷустуҷӯ пайвастшавӣ бо сервер гум шуд, дархости худро такрор кунед',
        return_to_apartments: 'Бозгашт ба объектҳо',
        validation: 'Хатои санҷиш',
        not_found: 'Чизе нодуруст шуд, ин саҳифа вуҷуд надорад',
    },
    success: {
        booked: 'Брон шуд',
        thanks: 'Ташаккур! Шумо {address}-ро бомуваффақият брон кардед',
        booking_info: 'Маълумот дар бораи брон',
        check_in: 'Даромад',
        check_out: 'Баромад',
        amount: 'Маблағ',
        prepaid: 'Пешпардохт анҷом дода шуд',
        pay_on_arrival: 'Дар ҷой пардохти боқимонда',
        message_for_you: 'Паём барои шумо',
        check_in_date_time: '{date}, аз {timeStart} то {timeEnd}',
        check_out_date_time: '{date}, аз {timeStart} то {timeEnd}',
        notifications: {
            title: 'Огоҳиномаҳои ройгон',
            description: 'Дар бораи бронкунии шумо маълумоти муҳим мефиристем',
            connect_button: 'Дар Telegram пайваст кунед',
        },
    },
    days: {
        day: '{count} рӯз | {count} рӯз | {count} рӯз | {count} рӯз | {count} рӯз',
    },
    loader: {
        loading: 'Бор шуда истодааст...',
        searching: 'Пешниҳодҳои дастрасро ҷустуҷӯ дорем...',
        checking: 'Нархҳоро санҷида истодаем...',
    },
    rules: {
        privacy_policy: 'Сиёсати коркарди маълумоти шахсӣ',
        accommodation_rules: 'Қоидаҳои иқомат',
        booking_rules: 'Қоидаҳои бронкунӣ',
        consent: {
            title: 'Ризоият ба коркарди маълумоти шахсӣ',
            title2: 'Сиёсати коркарди маълумоти шахсӣ',
            text: `Настоящим, я, действуя свободно, своей волей и в своем интересе, а также подтверждая свою дееспособность, предоставляя данные о себе, даю согласие {legalName}, ИНН {inn}, (далее – Оператор) на обработку следующих моих персональных данных, указанных мною при бронировании Проживания на сайте https://homereserve.ru или иным способом, с целью оформления и исполнения бронирования Проживания, в том числе оказания дополнительных услуг в Средстве/Объекте размещения Оператора: {<br>}

                    - фамилия, имя, отчество (при наличии); {<br>}
                    - контактная информация (номер телефона, адрес электронной почты); {<br>}
                    - гражданство; {<br>}
                    - дата рождения (число/месяц/год); {<br>}
                    - данные документа, удостоверяющего личность (серия, номер, дата выдачи, код подразделения, орган, выдавший документ, 
                    страна рождения, регион рождения, район, город, населенный пункт); {<br>}
                    - пол;  {<br>}
                    - адрес регистрации; {<br>}
                    - информация о гостях и их персональные данные. {<br>}

                    Для достижения указанной цели Оператор может осуществлять любые действия (операции) или совокупности действий (операций), 
                    совершаемых с использованием средств автоматизации или без использования таких средств с персональными данными, указанными выше,
                    включая сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, 
                    передачу (предоставление, доступ), обезличивание, блокирование, удаление, уничтожение персональных данных. {<br>}

                    Я даю согласие Оператору на передачу (предоставление, доступ) персональных данных, указанных выше, в адрес следующего юридического лица, действующего по поручению Оператора: ООО «Апартмент системс», ИНН 7729748911 ОГРН 1137746760381, юридический адрес: 119607, г. Москва, ул. Раменки, д. 25 к. 3, кв. 668, а также иным третьим лицам через ООО «Апартмент системс» (для целей интеграции с системами бронирования, CRM-системами) в целях автоматизации бизнес-процессов, централизованного хранения и управления данными, а также осуществление с ними следующих действий (операций): сбор, запись, систематизацию, накопление, хранение, уточнение (обновление, изменение), извлечение, использование, передачу (предоставление, доступ), обезличивание, блокирование, удаление, уничтожение. {<br>}
                    
                    Я подтверждаю, что предоставленные мной персональные данные являются точными, актуальными и достоверными, 
                    также обязуюсь своевременно информировать Оператора об изменениях в моих персональных данных по адресу электронной почты: 
                    {legalEmail}, либо в письменной форме на адрес: {legalAddress}. {<br>}

                    Настоящим подтверждаю, что в случае оформления мною заказа для третьих лиц, предоставляю персональные данные с их согласия. {<br>}
                    Настоящее согласие вступает в силу с момента его предоставления, путем проставления галочки на сайте https://homereserve.ru. {<br>}
                    Согласие действует до факта достижения цели обработки или до отзыва согласия. {<br>}

                    В соответствии с положениями ч. 2 ст. 9 Федерального закона от 27 июля 2006 г. № 152-ФЗ «О персональных данных», 
                    оставляю за собой право отозвать данное согласие посредством направления такого отзыва по адресу электронной почты: 
                    {legalEmail}, либо в письменной форме на адрес: {legalAddress}. {<br>}

                    Я предупрежден(а), что в случае отзыва согласия на обработку персональных данных Оператор вправе продолжить обработку 
                    персональных данных без согласия при наличии оснований, указанных в пп. 2-11 ч. 1 ст. 6, ч. 2 ст. 10 
                    Федерального закона от 27 июля 2006 г. № 152-ФЗ «О персональных данных»`,
        },
        privacy: {
            title: 'Сиёсати коркарди маълумоти шахсӣ',
            text: `1.ОБЩИЕ ПОЛОЖЕНИЯ {<br>}

                    1.1.Настоящая Политика в отношении обработки персональных данных (далее – Политика) разработана во исполнение требований п. 2 ч. 1 ст. 18.1 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных» в целях обеспечения защиты прав и свобод человека и гражданина при обработке его персональных данных, в том числе, защиты прав на неприкосновенность частной жизни, личную и семейную тайну. {<br>}
                    1.2.Политика действует в отношении всех персональных данных, которые обрабатывает {legalName}, ИНН {inn} (далее – Оператор). {<br>}
                    1.3.Политика распространяется на отношения в области обработки персональных данных, возникшие у Оператора как до, так и после утверждения Политики. {<br>}
                    1.4.Во исполнение требований ч. 2 ст. 18.1 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных», Политика публикуется в личном кабинете Оператора в RealtyCalendar. {<br>}

                    2.ОСНОВНЫЕ ПОНЯТИЯ, ИСПОЛЬЗУЕМЫЕ В ПОЛИТИКЕ {<br>}

                    2.1.Персональные данные – любая информация, относящаяся к прямо или косвенно определенному или определяемому физическому лицу (субъекту персональных данных); {<br>}
                    2.2.Оператор персональных данных (оператор) – государственный орган, муниципальный орган, юридическое или физическое лицо, самостоятельно или совместно с другими лицами организующие и (или) осуществляющие обработку персональных данных, а также определяющие цели обработки персональных данных, состав персональных данных, подлежащих обработке, действия (операции), совершаемые с персональными данными; {<br>}
                    2.3.Обработка персональных данных – любое действие (операция) или совокупность действий (операций) с персональными данными, совершаемых с использованием средств автоматизации или без их использования. Обработка персональных данных включает в себя в том числе: {<br>}
                    2.3.1.сбор; {<br>}
                    2.3.2.запись; {<br>}
                    2.3.3.систематизацию; {<br>}
                    2.3.4.накопление; {<br>}
                    2.3.5.хранение; {<br>}
                    2.3.6.уточнение (обновление, изменение); {<br>}
                    2.3.7.извлечение; {<br>}
                    2.3.8.использование; {<br>}
                    2.3.9.передачу (распространение, предоставление, доступ); {<br>}
                    2.3.10.обезличивание; {<br>}
                    2.3.11.блокирование; {<br>}
                    2.3.12.удаление; {<br>}
                    2.3.13.уничтожение. {<br>}
                    2.4.Автоматизированная обработка персональных данных – обработка персональных данных с помощью средств вычислительной техники; {<br>}
                    2.5.Распространение персональных данных – действия, направленные на раскрытие персональных данных неопределенному кругу лиц; {<br>}
                    2.6.Предоставление персональных данных – действия, направленные на раскрытие персональных данных определенному лицу или определенному кругу лиц; {<br>}
                    2.7.Блокирование персональных данных – временное прекращение обработки персональных данных (за исключением случаев, если обработка необходима для уточнения персональных данных); {<br>}
                    2.8.Уничтожение персональных данных – действия, в результате которых становится невозможным восстановить содержание персональных данных в информационной системе персональных данных и (или) в результате которых уничтожаются материальные носители персональных данных; {<br>}
                    2.9.Обезличивание персональных данных – действия, в результате которых становится невозможным без использования дополнительной информации определить принадлежность персональных данных конкретному субъекту персональных данных; {<br>}
                    2.10.Информационная система персональных данных – совокупность содержащихся в базах данных персональных данных и обеспечивающих их обработку информационных технологий и технических средств; {<br>}
                    2.11.Трансграничная передача персональных данных – передача персональных данных на территорию иностранного государства органу власти иностранного государства, иностранному физическому лицу или иностранному юридическому лицу. {<br>}

                    3.ОСНОВНЫЕ ПРАВА И ОБЯЗАННОСТИ ОПЕРАТОРА {<br>}

                    3.1.Оператор имеет право: {<br>}
                    3.1.1.самостоятельно определять состав и перечень мер, необходимых и достаточных для обеспечения выполнения обязанностей, предусмотренных Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных» и принятыми в соответствии с ним нормативными правовыми актами, если иное не предусмотрено Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных» или другими федеральными законами; {<br>}
                    3.1.2.поручить обработку персональных данных другому лицу с согласия субъекта персональных данных, если иное не предусмотрено федеральным законом, на основании заключаемого с этим лицом договора. Лицо, осуществляющее обработку персональных данных по поручению Оператора, обязано соблюдать принципы и правила обработки персональных данных, предусмотренные Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных»; {<br>}
                    3.1.3.в случае отзыва субъектом персональных данных согласия на обработку персональных данных Оператор вправе продолжить обработку персональных данных без согласия субъекта персональных данных при наличии оснований, указанных в Федеральном законе от 27.07.2006 г. № 152-ФЗ «О персональных данных». {<br>}
                    3.2. Оператор обязан: {<br>}
                    3.2.1.организовывать обработку персональных данных в соответствии с требованиями Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных»; {<br>}
                    3.2.2.отвечать на обращения и запросы субъектов персональных данных и их законных представителей в соответствии с требованиями Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных»; {<br>}
                    3.2.3.сообщать в уполномоченный орган по защите прав субъектов персональных данных (Федеральную службу по надзору в сфере связи, информационных технологий и массовых коммуникаций (Роскомнадзор)) по запросу этого органа необходимую информацию в течение 10 (десяти) рабочих дней с даты получения такого запроса. {<br>}

                    4.ОСНОВНЫЕ ПРАВА СУБЪЕКТА ПЕРСОНАЛЬНЫХ ДАННЫХ {<br>}

                    4.1.Субъект персональных данных имеет право: {<br>}
                    4.1.1.получать информацию, касающуюся обработки его персональных данных, за исключением случаев, предусмотренных федеральными законами. Сведения предоставляются субъекту персональных данных Оператором в доступной форме, и в них не должны содержаться персональные данные, относящиеся к другим субъектам персональных данных, за исключением случаев, когда имеются законные основания для раскрытия таких персональных данных. Перечень информации и порядок ее получения установлен Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных»; {<br>}
                    4.1.2.требовать от оператора уточнения его персональных данных, их блокирования или уничтожения в случае, если персональные данные являются неполными, устаревшими, неточными, незаконно полученными или не являются необходимыми для заявленной цели обработки, а также принимать предусмотренные законом меры по защите своих прав; {<br>}
                    4.1.3.выдвигать условие предварительного согласия при обработке персональных данных в целях продвижения на рынке товаров, работ и услуг; {<br>}
                    4.1.4.обжаловать в административном или судебном порядке неправомерные действия или бездействие Оператора при обработке его персональных данных. {<br>}
                    4.2. Контроль за исполнением требований настоящей Политики осуществляется Оператором или уполномоченным лицом, ответственным за организацию обработки персональных данных у Оператора. {<br>}
                    4.3. Ответственность за нарушение требований законодательства Российской Федерации и локальных нормативных актов Оператора в сфере обработки и защиты персональных данных определяется в соответствии с законодательством Российской Федерации. {<br>}

                    5.ЦЕЛИ СБОРА ПЕРСОНАЛЬНЫХ ДАННЫХ {<br>}

                    5.1.Обработка персональных данных ограничивается достижением конкретных, заранее определенных и законных целей. Не допускается обработка персональных данных, несовместимая с целями сбора персональных данных. {<br>}
                    5.2.Обработке подлежат только персональные данные, которые отвечают целям их обработки. {<br>}
                    5.3.Обработка Оператором персональных данных осуществляется в следующих целях: {<br>}
                    5.3.1.обеспечение соблюдения Конституции Российской Федерации, федеральных законов и иных нормативных правовых актов Российской Федерации; {<br>}
                    5.3.2.осуществление деятельности Оператора; {<br>}
                    5.3.3.ведение делопроизводства; {<br>}
                    5.3.4.заполнение и передача в органы исполнительной власти и иные уполномоченные организации требуемых форм отчетности; {<br>}
                    5.3.5.осуществление гражданско-правовых отношений; {<br>}
                    5.3.6.ведение бухгалтерского учета. {<br>}

                    6.ОБЪЕМ И КАТЕГОРИИ ОБРАБАТЫВАЕМЫХ ПЕРСОНАЛЬНЫХ ДАННЫХ, КАТЕГОРИИ СУБЪЕКТОВ ПЕРСОНАЛЬНЫХ ДАННЫХ {<br>}

                    6.1.Оператор может обрабатывать персональные данные следующих категорий субъектов персональных данных. {<br>}
                    6.1.1.Клиенты и контрагенты Оператора (физические лица): {<br>}
                    - фамилия, имя, отчество (при наличии); {<br>}
                    - контактная информация (номер телефона, адрес электронной почты); {<br>}
                    - гражданство; {<br>}
                    - дата рождения (число/месяц/год); {<br>}
                    - данные документа, удостоверяющего личность (серия, номер, дата выдачи, код подразделения, орган, выдавший документ, страна рождения, регион рождения, район, город, населенный пункт); {<br>}
                    - пол; {<br>}
                    - адрес регистрации; {<br>}
                    - информация о гостях и их персональные данные. {<br>}
                    6.2.Обработка Оператором биометрических персональных данных (сведений, которые характеризуют физиологические и биологические особенности человека, на основании которых можно установить его личность) не осуществляется. {<br>}
                    6.3.Оператором не осуществляется обработка специальных категорий персональных данных, касающихся расовой, национальной принадлежности, политических взглядов, религиозных или философских убеждений, состояния здоровья, интимной жизни, за исключением случаев, предусмотренных законодательством РФ. {<br>}

                    7.ПОРЯДОК И УСЛОВИЯ ОБРАБОТКИ ПЕРСОНАЛЬНЫХ ДАННЫХ {<br>}

                    7.1.Обработка персональных данных осуществляется Оператором в соответствии с требованиями законодательства Российской Федерации. {<br>}
                    7.2.Обработка персональных данных осуществляется с согласия субъектов персональных данных на обработку их персональных данных, а также без такового в случаях, предусмотренных законодательством Российской Федерации. {<br>}
                    7.3.Оператор осуществляет как автоматизированную, так и неавтоматизированную обработку персональных данных. {<br>}
                    7.4.К обработке персональных данных допускаются работники Оператора, в должностные обязанности которых входит обработка персональных данных. {<br>}
                    7.5.Обработка персональных данных осуществляется путем: {<br>}
                    7.5.1.получения персональных данных в устной и письменной форме непосредственно от субъектов персональных данных; {<br>}
                    7.5.2.получения персональных данных из общедоступных источников; {<br>}
                    7.5.3.внесения персональных данных в журналы, реестры и информационные системы Оператора; {<br>}
                    7.5.4.использования иных способов обработки персональных данных. {<br>}
                    7.6.Не допускается раскрытие третьим лицам и распространение персональных данных без согласия субъекта персональных данных, если иное не предусмотрено федеральным законом. Согласие на обработку персональных данных, разрешенных субъектом персональных данных для распространения, оформляется отдельно от иных согласий субъекта персональных данных на обработку его персональных данных. {<br>}
                    Требования к содержанию согласия на обработку персональных данных, разрешенных субъектом персональных данных для распространения, утверждены Приказом Роскомнадзора от 24.02.2021 г. № 18 (а в случае его отмены в последующем – в заменяющем его нормативно-правовом акте). {<br>}
                    7.7.Передача персональных данных органам дознания и следствия, в Федеральную налоговую службу, Социальный фонд Российской Федерации и другие уполномоченные органы исполнительной власти и организации осуществляется в соответствии с требованиями законодательства Российской Федерации. {<br>}
                    7.8.Оператор принимает необходимые правовые, организационные и технические меры для защиты персональных данных от неправомерного или случайного доступа к ним, уничтожения, изменения, блокирования, распространения и других несанкционированных действий, в том числе: {<br>}
                    - определяет угрозы безопасности персональных данных при их обработке; {<br>}
                    - принимает локальные нормативные акты и иные документы, регулирующие отношения в сфере обработки и защиты персональных данных; {<br>}
                    - назначает лиц, ответственных за обеспечение безопасности персональных данных в структурных подразделениях и информационных системах Оператора; {<br>}
                    - создает необходимые условия для работы с персональными данными; {<br>}
                    - организует учет документов, содержащих персональные данные; {<br>}
                    - организует работу с информационными системами, в которых обрабатываются персональные данные; {<br>}
                    - хранит персональные данные в условиях, при которых обеспечивается их сохранность и исключается неправомерный доступ к ним; {<br>}
                    - организует обучение работников Оператора, осуществляющих обработку персональных данных. {<br>}
                    7.9.Оператор осуществляет хранение персональных данных в форме, позволяющей определить субъекта персональных данных, не дольше, чем этого требуют цели обработки персональных данных, если срок хранения персональных данных не установлен федеральным законом, договором. {<br>}
                    7.10.При сборе персональных данных, в том числе посредством информационно-телекоммуникационной сети «Интернет», запись, систематизация, накопление, хранение, уточнение (обновление, изменение), извлечение персональных данных граждан Российской Федерации с использованием баз данных, находящихся за пределами территории Российской Федерации, не допускаются, за исключением случаев, указанных в пунктах 2, 3, 4, 8 части 1 статьи 6 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных». {<br>}

                    8.АКТУАЛИЗАЦИЯ, ИСПРАВЛЕНИЕ, УДАЛЕНИЕ И УНИЧТОЖЕНИЕ ПЕРСОНАЛЬНЫХ ДАННЫХ, ОТВЕТЫ НА ЗАПРОСЫ СУБЪЕКТОВ НА ДОСТУП К ПЕРСОНАЛЬНЫМ ДАННЫМ {<br>}

                    8.1.Подтверждение факта обработки персональных данных Оператором, правовые основания и цели обработки персональных данных, а также иные сведения, указанные в ч. 7 ст. 14 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных», предоставляются Оператором субъекту персональных данных или его представителю при обращении либо при получении запроса субъекта персональных данных или его представителя по адресу электронной почты: {legalEmail}, либо в письменной форме на адрес: {legalAddress}. {<br>}
                    В предоставляемые сведения не включаются персональные данные, относящиеся к другим субъектам персональных данных, за исключением случаев, когда имеются законные основания для раскрытия таких персональных данных. {<br>}
                    Запрос должен содержать: {<br>}
                    - номер основного документа, удостоверяющего личность субъекта персональных данных или его представителя, сведения о дате выдачи указанного документа и выдавшем его органе; {<br>}
                    - сведения, подтверждающие участие субъекта персональных данных в отношениях с Оператором (номер договора, дата заключения договора, условное словесное обозначение и (или) иные сведения), либо сведения, иным образом подтверждающие факт обработки персональных данных Оператором; {<br>}
                    - подпись субъекта персональных данных или его представителя. {<br>}
                    Запрос может быть направлен в форме электронного документа и подписан электронной подписью в соответствии с законодательством Российской Федерации. {<br>}
                    Если в обращении (запросе) субъекта персональных данных не отражены в соответствии с требованиями Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных» все необходимые сведения или субъект не обладает правами доступа к запрашиваемой информации, то ему направляется мотивированный отказ. {<br>}
                    Право субъекта персональных данных на доступ к его персональным данным может быть ограничено в соответствии с ч. 8 ст. 14 Федерального закона от 27.07.2006 г. № 152-ФЗ «О персональных данных», в том числе, если доступ субъекта персональных данных к его персональным данным нарушает права и законные интересы третьих лиц. {<br>}
                    8.2.В случае выявления неточных персональных данных при обращении субъекта персональных данных или его представителя либо по их запросу или по запросу Роскомнадзора Оператор осуществляет блокирование персональных данных, относящихся к этому субъекту персональных данных, с момента такого обращения или получения указанного запроса на период проверки, если блокирование персональных данных не нарушает права и законные интересы субъекта персональных данных или третьих лиц. {<br>}
                    В случае подтверждения факта неточности персональных данных Оператор на основании сведений, представленных субъектом персональных данных или его представителем либо Роскомнадзором, или иных необходимых документов уточняет персональные данные в течение семи рабочих дней со дня представления таких сведений и снимает блокирование персональных данных. {<br>}
                    8.3.При достижении целей обработки персональных данных, а также в случае отзыва субъектом персональных данных согласия на их обработку персональные данные подлежат уничтожению, если: {<br>}
                    - иное не предусмотрено договором, стороной которого, выгодоприобретателем или поручителем, по которому является субъект персональных данных; {<br>}
                    - Оператор не вправе осуществлять обработку без согласия субъекта персональных данных на основаниях, предусмотренных Федеральным законом от 27.07.2006 г. № 152-ФЗ «О персональных данных» или иными федеральными законами; {<br>}
                    - иное не предусмотрено другим соглашением между Оператором и субъектом персональных данных. {<br>}

                    9.ЗАКЛЮЧИТЕЛЬНЫЕ ПОЛОЖЕНИЯ {<br>}

                    9.1.Политика вступает в силу с момента утверждения Оператором и действует бессрочно. {<br>}
                    9.2.Внесение изменений, дополнение или отмена Политики производится на основании принятия Оператором соответствующего решения. {<br>}`,
        },
        booking: {
            main: {
                title: 'Қоидаҳои бронкунӣ',
            },
            another: {
                title: 'Қоидаҳои дигари бронкунӣ',
            },
            refund: {
                title: 'Қоидаҳои баргардонидани пешпардохт',
            },
        },
        residence: {
            title: 'Қоидаҳои истиқомат',
        },
        foreign_agreement: {
            title: 'Шартҳои бронкунӣ, қоидаҳои истиқомат ва сиёсати махфият',
        },
    },
    hotels: {
        map: {
            close_list: 'Пӯшидани рӯйхат',
        },
    },
    apartment: {
        arrival_departure_text: 'Воридшавӣ аз {in_start} то {in_end}, баромад аз {out_start} то {out_end}',
    },
    payment: {
        info: {
            error: {
                title: 'Пайванд куҳна шудааст',
                description: 'Лутфан ба менеҷери худ муроҷиат кунед:',
                agreement_required: 'Бо шартҳои оферта розӣ шудан лозим аст',
            },
            check_in: 'Воридшавӣ',
            check_out: 'Баромад',
            amount: 'Арзиши умумӣ',
            paid_amount: 'Пардохт шудааст',
            amount_left: 'Маблағи пардохт',
            time_from: 'аз {from}',
            time_to: 'то {to}',
        },
        status: {
            success: 'Пардохт шудааст',
            not_paid: 'Истиқомат пардохт нашудааст',
        },
    },
    gallery: {
        large_photo: 'Сурати калон',
        small_photo: 'Сурати хурд',
        more_photos: '+{count} сурат',
    },
};
